import Api from '@/services/Api'
const path = 'users'

export default {
    register(credentials) {
        return Api().post('register', credentials);
    },
    update(credentials) {
        return Api().post(path + `/update`, credentials);
    },
    login(userName, pass) {
        return Api().get(path + `/login`, {
            params: {
                userName: userName,
                password: pass
            }
        })
    }
}